[
  {
    "data": "2026-05-08",
    "valor": 14.5
  },
  {
    "data": "2026-05-09",
    "valor": 14.5
  },
  {
    "data": "2026-05-10",
    "valor": 14.5
  },
  {
    "data": "2026-05-11",
    "valor": 14.5
  },
  {
    "data": "2026-05-12",
    "valor": 14.5
  },
  {
    "data": "2026-05-13",
    "valor": 14.5
  },
  {
    "data": "2026-05-14",
    "valor": 14.5
  },
  {
    "data": "2026-05-15",
    "valor": 14.5
  },
  {
    "data": "2026-05-16",
    "valor": 14.5
  },
  {
    "data": "2026-05-17",
    "valor": 14.5
  },
  {
    "data": "2026-05-18",
    "valor": 14.5
  },
  {
    "data": "2026-05-19",
    "valor": 14.5
  },
  {
    "data": "2026-05-20",
    "valor": 14.5
  },
  {
    "data": "2026-05-21",
    "valor": 14.5
  },
  {
    "data": "2026-05-22",
    "valor": 14.5
  },
  {
    "data": "2026-05-23",
    "valor": 14.5
  },
  {
    "data": "2026-05-24",
    "valor": 14.5
  },
  {
    "data": "2026-05-25",
    "valor": 14.5
  },
  {
    "data": "2026-05-26",
    "valor": 14.5
  },
  {
    "data": "2026-05-27",
    "valor": 14.5
  },
  {
    "data": "2026-05-28",
    "valor": 14.5
  },
  {
    "data": "2026-05-29",
    "valor": 14.5
  },
  {
    "data": "2026-05-30",
    "valor": 14.5
  },
  {
    "data": "2026-05-31",
    "valor": 14.5
  },
  {
    "data": "2026-06-01",
    "valor": 14.5
  },
  {
    "data": "2026-06-02",
    "valor": 14.5
  },
  {
    "data": "2026-06-03",
    "valor": 14.5
  },
  {
    "data": "2026-06-04",
    "valor": 14.5
  },
  {
    "data": "2026-06-05",
    "valor": 14.5
  },
  {
    "data": "2026-06-06",
    "valor": 14.5
  },
  {
    "data": "2026-06-07",
    "valor": 14.5
  },
  {
    "data": "2026-06-08",
    "valor": 14.5
  },
  {
    "data": "2026-06-09",
    "valor": 14.5
  },
  {
    "data": "2026-06-10",
    "valor": 14.5
  },
  {
    "data": "2026-06-11",
    "valor": 14.5
  },
  {
    "data": "2026-06-12",
    "valor": 14.5
  },
  {
    "data": "2026-06-13",
    "valor": 14.5
  },
  {
    "data": "2026-06-14",
    "valor": 14.5
  },
  {
    "data": "2026-06-15",
    "valor": 14.5
  },
  {
    "data": "2026-06-16",
    "valor": 14.5
  },
  {
    "data": "2026-06-17",
    "valor": 14.5
  },
  {
    "data": "2026-06-18",
    "valor": 14.25
  },
  {
    "data": "2026-06-19",
    "valor": 14.25
  },
  {
    "data": "2026-06-20",
    "valor": 14.25
  },
  {
    "data": "2026-06-21",
    "valor": 14.25
  },
  {
    "data": "2026-06-22",
    "valor": 14.25
  },
  {
    "data": "2026-06-23",
    "valor": 14.25
  },
  {
    "data": "2026-06-24",
    "valor": 14.25
  },
  {
    "data": "2026-06-25",
    "valor": 14.25
  },
  {
    "data": "2026-06-26",
    "valor": 14.25
  },
  {
    "data": "2026-06-27",
    "valor": 14.25
  },
  {
    "data": "2026-06-28",
    "valor": 14.25
  },
  {
    "data": "2026-06-29",
    "valor": 14.25
  },
  {
    "data": "2026-06-30",
    "valor": 14.25
  },
  {
    "data": "2026-07-01",
    "valor": 14.25
  },
  {
    "data": "2026-07-02",
    "valor": 14.25
  },
  {
    "data": "2026-07-03",
    "valor": 14.25
  },
  {
    "data": "2026-07-04",
    "valor": 14.25
  },
  {
    "data": "2026-07-05",
    "valor": 14.25
  },
  {
    "data": "2026-07-06",
    "valor": 14.25
  },
  {
    "data": "2026-07-07",
    "valor": 14.25
  },
  {
    "data": "2026-07-08",
    "valor": 14.25
  },
  {
    "data": "2026-07-09",
    "valor": 14.25
  },
  {
    "data": "2026-07-10",
    "valor": 14.25
  },
  {
    "data": "2026-07-11",
    "valor": 14.25
  },
  {
    "data": "2026-07-12",
    "valor": 14.25
  },
  {
    "data": "2026-07-13",
    "valor": 14.25
  },
  {
    "data": "2026-07-14",
    "valor": 14.25
  },
  {
    "data": "2026-07-15",
    "valor": 14.25
  },
  {
    "data": "2026-07-16",
    "valor": 14.25
  },
  {
    "data": "2026-07-17",
    "valor": 14.25
  },
  {
    "data": "2026-07-18",
    "valor": 14.25
  },
  {
    "data": "2026-07-19",
    "valor": 14.25
  },
  {
    "data": "2026-07-20",
    "valor": 14.25
  },
  {
    "data": "2026-07-21",
    "valor": 14.25
  },
  {
    "data": "2026-07-22",
    "valor": 14.25
  },
  {
    "data": "2026-07-23",
    "valor": 14.25
  },
  {
    "data": "2026-07-24",
    "valor": 14.25
  },
  {
    "data": "2026-07-25",
    "valor": 14.25
  },
  {
    "data": "2026-07-26",
    "valor": 14.25
  },
  {
    "data": "2026-07-27",
    "valor": 14.25
  },
  {
    "data": "2026-07-28",
    "valor": 14.25
  },
  {
    "data": "2026-07-29",
    "valor": 14.25
  },
  {
    "data": "2026-07-30",
    "valor": 14.25
  },
  {
    "data": "2026-07-31",
    "valor": 14.25
  },
  {
    "data": "2026-08-01",
    "valor": 14.25
  },
  {
    "data": "2026-08-02",
    "valor": 14.25
  },
  {
    "data": "2026-08-03",
    "valor": 14.25
  },
  {
    "data": "2026-08-04",
    "valor": 14.25
  },
  {
    "data": "2026-08-05",
    "valor": 14.25
  }
]
